var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 41.0625C43.3818 41.0625 46.5312 37.9131 46.5312 34.0312C46.5312 30.1494 43.3818 27 39.5 27C35.6182 27 32.4688 30.1494 32.4688 34.0312C32.4688 37.9131 35.6182 41.0625 39.5 41.0625ZM45.75 42.625H43.0596C41.9756 43.123 40.7695 43.4062 39.5 43.4062C38.2305 43.4062 37.0293 43.123 35.9404 42.625H33.25C29.7979 42.625 27 45.4229 27 48.875V49.6562C27 50.9502 28.0498 52 29.3438 52H49.6562C50.9502 52 52 50.9502 52 49.6562V48.875C52 45.4229 49.2021 42.625 45.75 42.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUser);
export default __webpack_public_path__ + "static/media/noUser.e23111c1afe78c014fb8287d09e5cb44.svg";
export { ForwardRef as ReactComponent };